<app-modal-header title="Save / Load: {{ what ? what : 'User Settings' }}" [close]="onClose"></app-modal-header>

<div class="app-content app-content--no-scroll">
  @if (savedEntries) {
    <div id="body-grid">
      <ng-container>
        @if (desc) {
          <div id="saved-settings-h">
            <div class="orange-msg">
              <p>{{ desc }}</p>
            </div>
          </div>
        }
        <div>
          <div class="saved-settings-header">Saved Settings</div>
        </div>
        <div id="saved-settings" class="special-scroller">
          @if (getNumberOfSavedDocuments) {
              @for (save of savedEntriesOrder; track save) {
                <div [class.selected]="selectedSavedEntry === save"
                     class="saved-settings-list"
                     (click)="onSelectChange(save)" (dblclick)="onSelectAndLoadChange(save)">
                  <div class="saved-settings-item">{{ save }}</div>
                  <div class="save-details">
                    {{ getDisplayDate(savedEntries[save]) }}
                    <button type="button" [disabled]="save !== selectedSavedEntry" (click)="onDelete(save)">
                      <app-display-icon [icon]="icons.deleteOutline"></app-display-icon>
                    </button>
                  </div>
                </div>
              }
          } @else {
            <div>
              <div>
                <div class="no-saves">No Saved Settings</div>
              </div>
            </div>
          }
        </div>
      </ng-container>
      <div class="actions-row">
          @if (getSaveObj) {
            <input [formControl]="saveForm" (input)="onInputChange()">
            <button type="button" [disabled]="saveForm.invalid">
              <app-display-icon  [icon]="icons.contentSaveOutline" (click)="onSaveEntry()"></app-display-icon>
            </button>
          }
          <app-shared-button size="small" [colour]="'secondary'" [fill]="false" [disabled]="!selectedSavedEntry" (buttonClicked)="onLoadEntry()">Load</app-shared-button>
      </div>
    </div>
  } @else {
    <div id="loading">
      <span>Loading Saves...</span>
      <span class="spinner" aria-hidden="true"></span>
    </div>
  }
</div>

